import classNames from 'classnames'

import { Button } from 'components/ui/Button/Button'
import { ReactNode, useRef, useState } from 'react'

import './upload.style.css'

const inputId = 'file-upload-input'

type Props = {
  hint?: ReactNode
  loading?: boolean
  onChange?: (file: File) => void
  onSubmit?: (file: File) => void
}

export const Upload = ({ onSubmit, onChange, loading, hint }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [file, setFile] = useState<File>()

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files.length === 0) return

    const handledFile = event.target.files[0]
    setFile(handledFile)
    onChange?.(handledFile)
  }

  const handleOnSubmit = () => {
    onSubmit?.(file)
    setFile(undefined)
  }

  const handleOnClick = () => {
    if (!inputRef) return
    inputRef.current.value = ''
  }

  const classname = classNames('upload-label', {
    'upload-label-disabled': loading,
  })

  return (
    <>
      <div className="upload-wrapper">
        <label className={classname} htmlFor={inputId}>
          <span className="upload-filename">
            {file === undefined ? 'Файл не выбран' : file.name}
          </span>
          <input
            ref={inputRef}
            id={inputId}
            type="file"
            disabled={loading}
            onChange={handleFileChange}
            onClick={handleOnClick}
          />
          <span className="upload-button btn btn-primary">Добавить</span>
        </label>
        {hint}
      </div>
      <Button title="Отправить" isLoading={loading} handleOnSubmit={handleOnSubmit} />
    </>
  )
}
